import React from 'react';
import {styled} from "@mui/material/styles";
import {autocompleteClasses} from "@mui/material/Autocomplete";

interface Props {
  anchorEl?: any;
  disablePortal?: boolean;
  open: boolean;
}

const Autocomplete = styled('div')(({theme}) => ({
  [`& .${autocompleteClasses.paper}`]: {
    boxShadow: 'none',
    margin: 0,
    color: 'inherit',
    fontSize: 13,
    padding: 0,
    minWidth: 220
  },
  [`& .${autocompleteClasses.listbox}`]: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1c2128',
    padding: 0,
    borderRadius: 0,
    [`& .${autocompleteClasses.option}`]: {
      minHeight: 'auto',
      alignItems: 'flex-start',
      padding: 8,
      borderBottom: `1px solid  ${
        theme.palette.mode === 'light' ? ' #eaecef' : '#30363d'
      }`,
      '&[aria-selected="true"]': {
        backgroundColor: 'transparent',
      },
      '&[data-focus="true"], &[data-focus="true"][aria-selected="true"]': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  [`&.${autocompleteClasses.popperDisablePortal}`]: {
    position: 'relative',
    width: '100% !important',
    maxWidth: '220px'
  },
}));


const Popper = (props: Props) => {
  const {disablePortal, anchorEl, open, ...other} = props;
  return <Autocomplete {...other} />;
};

export default Popper;
